import React, { useState } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import { setCurrentStep, setShowPopUp, validateCustomer, setSelectedPhoneNumber } from '../OwnershipTransferSlice';
import { OwnershipTransferStep, OwnershipTransferActionType, OwnershipTransferActionTypeDescription } from '../Constant/Constant';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import TextInputWithButton from '../../../Shared/TextInputWithButton/TextInputWithButton';
import { validateInput, TextInputEnum } from '../../../../utilities/validation/InputValidation';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import { dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText } from '../Reports/dwhReports'

const ValidateCustomer = (props) => {
  const [error, setError] = useState('');
  const [buttonError, setButtonError] = useState(false);
  const numberRegex = /^\d+$/;

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.LineSearchPage,
        messageText: DWHMessageText.LineSearchPageDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  function nextStep() {
    if (props.data.customerValidationResult?.accepted) {

      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.LineSearchPage,
        messageText: DWHMessageText.LineSearchPageButtonClicked,
        status: DWHStatus.Ongoing,
      });

      if (props.data.currentEquipmentObligations?.length != 0) {
        props.setCurrentStep(OwnershipTransferStep.EquipmentObligations);
      } else if (props.data.selectedActionType == OwnershipTransferActionType.PrivateToBusiness) {
        props.setCurrentStep(OwnershipTransferStep.FutureAccountType);
      } else {
        props.setCurrentStep(OwnershipTransferStep.CustomerForm);
      }
    } else {
      setButtonError(true);
    }
  }

  function submitValidation() {
    setButtonError(false);
    var error = validateInput(props.data.selectedPhoneNumber, TextInputEnum.Phone);

    if (!error) {

      dwhGeneralReport({
        data: { ...props.data, userDetails: props.userDetails, portalsBlock: props.portalsBlock },
        actionType: DwhActionType.LineSearchPage,
        messageText: DWHMessageText.LineSearchPageSearchButtonClicked,
        status: DWHStatus.Ongoing,
      });


      let orgId = props.portalsBlock.selectedHetPayId;
      if (!orgId) {
        orgId = props.portalsBlock.privateCompanyList?.find((c) => c.idNumber == props.portalsBlock.selectedHetPay)?.orgId;
      }
      const req = {
        OrgId: orgId,
        ActionType: props.data.selectedActionType,
        SubscriberPhoneNumber: props.data.selectedPhoneNumber,
      };
      setError('');
      props.validateCustomer(req);
    } else {
      setError(error);
    }
  }
  return (
    <div className='ownership-transfer-validate-customer ownership-transfer-step'>
      <div className='l-title '>חיפוש מנוי</div>
      <div className='m-title'>מה מספר המנוי שיעבור בעלות {OwnershipTransferActionTypeDescription[props.data.selectedActionType]} ?</div>
      <div className='stepContainer'>
        <div className=''>
          <TextInputWithButton
            placeholder={'הקלידו מספר מנוי'}
            value={props.data.selectedPhoneNumber}
            name={'phoneNumber'}
            type='text'
            error={error}
            pattern='[0-9]*'
            inputMode='numeric'
            maxLength='10'
            onChange={(e) => {
              if (numberRegex.test(e.target.value) || e.target.value == '') {
                props.setSelectedPhoneNumber(e.target.value)
              }
            }}
            buttonAction={() => {
              submitValidation();
            }}
            result={props.data.customerValidationResult}
          />
        </div>
      </div>
      <div className='continue-button'>
        {buttonError && <div className='error center'>כדי להמשיך יש לסיים בדיקת לקוח</div>}
        <BtnSubmit onclick={nextStep} text={'אפשר להמשיך'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransfer,
  portalsBlock: state.portalsBlock,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  validateCustomer,
  setSelectedPhoneNumber,
};

export default connect(mapStateToProps, mapDispatchToProps)(ValidateCustomer);
